module.exports = __webpack_public_path__ + "static/images/renwu4.41a95db.jpg";